import VueMitter from "@nguyenshort/vue3-mitt" // Replacement for event bus

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.use(VueMitter)
})
